// extracted by mini-css-extract-plugin
module.exports = {"label-chip":"PersistentDrawerLeft_label-chip__3Bzuu"};